import { DashboardHeatingOperatingModeValue } from '@vi-iot/client/index';

export namespace HeatingCircuitHelper {
  export enum HeatingOperatingProgramsSchema {
    reducedHeating = 'reducedHeating',
    normalHeating = 'normalHeating',
    comfortHeating = 'comfortHeating',
    fixed = 'fixed',
    frostprotection = 'frostprotection',
    reducedEnergySaving = 'reducedEnergySaving',
    normalEnergySaving = 'normalEnergySaving',
    comfortEnergySaving = 'comfortEnergySaving',
    reducedCooling = 'reducedCooling',
    normalCooling = 'normalCooling',
    comfortCooling = 'comfortCooling',
    reduced = 'reduced',
    normal = 'normal',
    comfort = 'comfort',
    screedDrying = 'screedDrying',
    unknown = 'unknown',
    standby = 'standby',
    heating = 'heating',
    holidayAtHome = 'holidayAtHome',
    holiday = 'holiday',
    noDemand = 'noDemand',
    reducedCoolingEnergySaving = 'reducedCoolingEnergySaving',
    comfortCoolingEnergySaving = 'comfortCoolingEnergySaving',
    normalCoolingEnergySaving = 'normalCoolingEnergySaving',
  }

  export const isCircuitTemperatureVisible = (
    operatingMode: DashboardHeatingOperatingModeValue,
    operatingProgram: HeatingOperatingProgramsSchema
  ): boolean => {
    const energySavingPrograms = [
      HeatingOperatingProgramsSchema.standby,
      HeatingOperatingProgramsSchema.reducedEnergySaving,
      HeatingOperatingProgramsSchema.normalEnergySaving,
      HeatingOperatingProgramsSchema.comfortEnergySaving,
      HeatingOperatingProgramsSchema.reducedCoolingEnergySaving,
      HeatingOperatingProgramsSchema.normalCoolingEnergySaving,
      HeatingOperatingProgramsSchema.comfortCoolingEnergySaving,
    ];

    return (
      operatingMode !== DashboardHeatingOperatingModeValue.standby &&
      !energySavingPrograms.includes(operatingProgram)
    );
  };
}
